import { Box, CircularProgress, Grid } from "@mui/material"
import {
  FormContainer,
  TextFieldElement,
  UseFormReturn,
} from "react-hook-form-mui"
import { useMemo } from "react"
import { Filter } from "@/modules/adv2/components/filters/filter"
import {
  useAgentsListQuery,
  useCampaignsListQuery,
  useLocationsListQuery,
  useTypesListQuery,
} from "@/modules/adv2/store"
import { ADV } from "@/modules/adv2/interfaces"

const FILTERS_LABELS: { [key: string]: string } = {
  cities: "Город",
  agents: "Агент",
  campaigns: "Кампания",
  bot_type_ids: "Тип бота",
}

/**
 * Filter form shape. Lives only in react-hook-form state (no redux), so it is
 * intentionally not persisted across page reloads.
 */
export interface UserFiltersForm {
  cities?: number[]
  agents?: number[]
  campaigns?: number[]
  bot_type_ids?: number[]
  limit?: number
}

interface IProps {
  formContext: UseFormReturn<UserFiltersForm>
  disabled?: boolean
}
export const UserFilters = ({ formContext, disabled }: IProps) => {
  const { data: locations, isLoading: isLocationsLoading } =
    useLocationsListQuery({})
  const { data: agents, isLoading: isAgentsLoading } = useAgentsListQuery({})
  const { data: campaigns, isLoading: isCampaignsLoading } =
    useCampaignsListQuery({})
  const { data: botsTypes, isLoading: isBotsTypesLoading } = useTypesListQuery({
    queryParams: { table: "bots" },
  })

  const filters: Record<string, ADV.Filter[] | undefined> = useMemo(
    () => ({ cities: locations, agents, campaigns, bot_type_ids: botsTypes }),
    [locations, agents, campaigns, botsTypes],
  )

  const isLoading =
    isAgentsLoading ||
    isLocationsLoading ||
    isCampaignsLoading ||
    isBotsTypesLoading

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" my={1}>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <FormContainer formContext={formContext}>
      <Grid container spacing={1} alignItems="stretch" my={1}>
        {Object.keys(filters ?? {}).map((key) => (
          <Grid item xs={12} sm={6} md={4} xl={2} key={`filter_${key}`}>
            <Filter
              name={key}
              label={FILTERS_LABELS[key]}
              isLoading={isLoading}
              multiple={true}
              options={filters?.[key]}
              disabled={disabled}
            />
          </Grid>
        ))}
        <Grid item xs={12} sm={6} md={4} xl={2}>
          <TextFieldElement<UserFiltersForm>
            name="limit"
            label="Кол-во"
            type="number"
            disabled={disabled}
            inputProps={{
              step: 100,
              min: 0,
            }}
          />
        </Grid>
      </Grid>
    </FormContainer>
  )
}
